exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs18[data-v-4569c508] {\n  font-size: 18px;\n}\n.insurance-link[data-v-4569c508] {\n  color: #11bb2e;\n}\n@media (max-width: 576px) {\n.w-100-mobile[data-v-4569c508] {\n    width: 100%;\n}\n}\n", ""]);

// exports
